import {createElement as h} from "react";

import {cs}         from "./chain-services";
import {Link}       from "./cst2";
import {UseState}   from "./use-state";

export const SessionStorageState = <T>({storageKey, defaultData=undefined, next}:{
    storageKey  : string,
    defaultData : T,
    next        : Link<JSX.Element, {
        value       : T,
        onChange    : (v:T) => void,
    }>,
}) => cs(
    ["state", (_, next) => h(UseState, {
        getInitValue: () => {
            const str = sessionStorage.getItem(storageKey);
            if (!str) {
                return defaultData;
            }
            return JSON.parse(str);
        },
        next,
    })],

    ({state}) => next({
        value: state.value,
        onChange: (value) => {
            state.onChange(value);

            sessionStorage.setItem(storageKey, JSON.stringify(value));
        },
    }),
);
